import type { FeedbackType, Role } from '@cockpit/shared';
import { TABS } from './navigation';

/** Écrans hors onglets qu'on peut aussi signaler. */
const EXTRA_SCREENS: Record<string, string> = {
  notifications: 'Notifications',
  setup: 'Première configuration',
};

/** Choix « Où ? » de Retours : les onglets visibles (sauf Retours), puis les autres écrans et « Autre ». */
export function feedbackScreens(role: Role | null | undefined): string[] {
  const tabs = TABS.filter((tab) => tab.name !== 'retours' && (!tab.adminOnly || role === 'ADMIN')).map(
    (tab) => tab.label,
  );
  const extra = Object.entries(EXTRA_SCREENS)
    .filter(([name]) => name !== 'setup' || role === 'ADMIN')
    .map(([, label]) => label);
  return [...tabs, ...extra, 'Autre'];
}

/** Libellé de l'écran d'origine (paramètre `from` : nom de route ou d'onglet), ou null. */
export function screenLabelFor(from: unknown): string | null {
  if (typeof from !== 'string' || !from) return null;
  // Lot AH [29] : les sections des Réglages (`reglages-projets`…) sont signalées comme « Réglages ».
  if (from.startsWith('reglages-')) return 'Réglages';
  return TABS.find((tab) => tab.name === from)?.label ?? EXTRA_SCREENS[from] ?? null;
}

/**
 * Lot AQ : écran à présélectionner dans « Où ? » pour l'écran affiché (onglet de la route, ou son nom) ; « Autre »
 * quand il n'est pas dans la liste (Retours lui-même, Mode écran…).
 */
export function currentScreenLabel(from: unknown, screens: readonly string[]): string {
  const label = screenLabelFor(from);
  if (label && screens.includes(label)) return label;
  return screens.includes('Autre') ? 'Autre' : (screens[0] ?? 'Autre');
}

/** Lot AQ : brouillon d'un retour (bulle « Faire un retour » ou page Retours). */
export interface FeedbackDraft {
  type: FeedbackType;
  screen: string;
  text: string;
  files: File[];
  /** Lot AD : conversation de l'assistant jointe au retour. */
  conversationId: string | null;
  /** Lot AD : constat de l'assistant, modifiable. */
  observed: string;
}

export function emptyFeedbackDraft(screen = ''): FeedbackDraft {
  return { type: 'BUG', screen, text: '', files: [], conversationId: null, observed: '' };
}
